// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2vAp6","info":"Note_info__2OE5B","note":"Note_note__2tqU4","actions":"Note_actions__12iDp"};